export class Nyukyokeiyaku {
    orgNyukyokeiyakuNo = -1;
    nyukyokeiyakuNo = -1;
    jokyoKb = -1;
    postCode = "";
    bukkenName = "";
    roomNumber = "";
    adr1 = "";
    adr2 = "";
    bukkenNameWithRoom = "";
    addressAll = "";
    nyukyosha = "";
    keiyakuYmd = "";
    shopName = "";
    shopPostcode = "";
    shopAdr1 = "";
    shopAdr2 = "";
    seikyuTotal = -1;
    roomSb = -1;
    taikyoStatus = -1;
    address = "";
}
